
import {
  MultiCurrencyUnitPrice,
} from '@dapi/sdk';
import {
  createMultiCurrencyUnitPrice,
  createUnitPrice,
  MockUnitPrice,
} from '@dapi/sdk/spec';
import {
  multiCurrencyPrice,
  price,
} from './price';


export const unitPrice: MockUnitPrice = createUnitPrice({
  template: {
    travelerIds: ['ADT-1'],
    prices: [price]
  }
});

export const MultiUnitPrice: MultiCurrencyUnitPrice = createMultiCurrencyUnitPrice({
  template: {
    travelerIds: ['TRAVELER-0-MOCK'],
    prices: [multiCurrencyPrice]
  }
});

